<template>
  <div class="gatherOrderApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="crumb">一日游卡套餐
      <a @click="gatherHref">激活游卡<i class="el-icon-arrow-right"></i></a>
    </div>
    <ul v-if="setGatherOrder.length > 0">
      <li v-for="(item,i) in setGatherOrder" @click="$router.push('gatherdetail?id='+item.gather_id)">
        <h2>{{item.title}}</h2>
        <p>单号：{{item.number}}</p>
        <p>有效时间：{{item.starttime}} ~ {{item.endtime}}</p>
        <p>绑定时间：{{item.bindtime}}</p>
        <p>绑定手机：{{item.phone}}</p>
        <div class="expired" v-if="item.expired > 0">已过期{{item.expired}}天</div>
        <a>查看<i class="el-icon-arrow-right"></i></a>
      </li>
    </ul>
    <div class="none" v-if="setGatherOrder.length <= 0">暂无数据，<a @click="gatherHref">激活游卡<i class="el-icon-arrow-right"></i></a></div>
  </div>
</template>

<script> 
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        userData:[],
        baseUrl:'',
        code:'',
        setGatherOrder:[]
      };
    },

    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/gatherorder');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        this.getGatherOrder();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      gatherHref:function(){
        window.location.href= this.$url + '/main/gathercode'
      },
      getGatherOrder:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/gather/getUserPan',
          data:{
            user_id:that.userData.id
          },
          dataType:'json',
          success:function(data){
            if(data.status == 200){
              that.setGatherOrder = data.data;
            }else{
              that.$alert(data.message,'提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          that.getGatherOrder();
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .gatherOrderApp{
    max-width:640px;
    margin:0 auto;
    background:#ececec;
  }
  .gatherOrderApp .crumb{
    width:96%;
    margin:0 auto;
    padding:12px 0;
    font-size:15px;
    color:#1C222B
  }
  .gatherOrderApp .crumb a{
    float:right;
    color:#00A870;
    font-size:14px
  }
  .gatherOrderApp ul{
    width:96%;
    margin:0 auto;
  }
  .gatherOrderApp ul li{
    background:#fff;
    margin-bottom:12px;
    border-radius:6px;
    padding:12px;
    position:relative;
  }
  .gatherOrderApp ul li h2{
    font-size:16px;
    color:#1C222B
  }
  .gatherOrderApp ul li p{
    font-size:14px;
    color:#3b3b3b;
    padding-top:6px
  }
  .gatherOrderApp ul li .expired{
    font-weight: bold;
    font-size: 14px;
    color: #E34D59;
    padding-top:6px
  }
  .gatherOrderApp ul li a{
    bottom:15px;
    right:15px;
    position:absolute;
    border: 1px solid #0052D9;
    border-radius: 3px;
    width: 64px;
    font-size: 14px;
    color: #0052D9;
    text-align:center;
    height: 24px;
    line-height: 25px;
  }
  .gatherOrderApp .none{
    font-size:14px;
    color:#6b6b6b;
    text-align:center;
    padding-top:70%;
  }
  .gatherOrderApp .none a{
    color:#00A870;
    font-size:14px
  }
</style>